// components/common/FormInput.js
import React from "react";

const FormInput = ({ label, type = "text", name, register, errors }) => {
  return (
    <div className="form-group">
      <label className="form-label">{label}</label>
      <input type={type} className="form-control" {...register(name)} />
      <p className="text-danger">{errors[name]?.message}</p>
    </div>
  );
};

export default FormInput;
